
export default function Services(){
  return (
    <div className="container py-12">
      <h2 className="text-3xl font-bold mb-4">Services</h2>
      <div className="grid md:grid-cols-3 gap-6">
        {['Paid Ads','SEO','CRO','Email & SMS','Analytics','Creative'].map(s => (
          <div key={s} className="card p-6">
            <div className="font-semibold text-lg">{s}</div>
            <p className="mt-2 text-sm opacity-80">Outcome-focused engagements with clear deliverables and timelines.</p>
          </div>
        ))}
      </div>
    </div>
  )
}
